<div class="filter-more-item">
  <label class="upper-label" for="minYearBuilt">Year built</label>

  <div class="inline-grid gap-x-3 grid-cols-2 w-full">
    <div class="label label-col2">
      <app-shared-input
        label="Min"
        for="minYearBuilt"
        [value]="minValue || 'any'"
      >
        <input
          id="minYearBuilt"
          name="minYearBuilt"
          type="text"
          placeholder="No min"
          (change)="handleChange()"
          [(ngModel)]="minValue"
          (focus)="selectAll($event)"
          inputmode="numeric"
          mask="0000"
        />
      </app-shared-input>
    </div>

    <div class="label label-col2">
      <app-shared-input
        label="Max"
        for="maxYearBuilt"
        [value]="maxValue || 'any'"
      >
        <input
          id="maxYearBuilt"
          name="maxYearBuilt"
          type="text"
          placeholder="No max"
          (change)="handleChange()"
          [(ngModel)]="maxValue"
          (focus)="selectAll($event)"
          inputmode="numeric"
          mask="0000"
        />
      </app-shared-input>
    </div>
  </div>
</div>
